<template>
  <div class="image-container">
    <img src="../../../../public/img/logo.png" alt="Imagen centrada" />
  </div>
</template>

<script>
export default {
  name: 'CenteredImage'
}
</script>

<style scoped>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
